module.exports = __webpack_public_path__ + "img/childu_event_btn.c66a0d6d.png";